// Helpers réutilisables (comme tu fais déjà dans Hotel/Circuit)

export const safe = (v, fallback = "-") =>
  v === null || v === undefined || v === "" ? fallback : v;

export const pick = (obj, paths, fallback = null) => {
  for (const p of paths) {
    const v = p.split(".").reduce((acc, k) => (acc ? acc[k] : undefined), obj);
    if (v !== undefined && v !== null && v !== "") return v;
  }
  return fallback;
};

export const norm = (s) => String(s || "").trim().toLowerCase();

export const formatDate = (d) => {
  if (!d) return "-";
  try {
    return new Date(d).toLocaleString("fr-FR");
  } catch {
    return String(d);
  }
};
